import React from 'react'
import cx from 'classnames'

import styles from './Arrow.module.scss'

type ArrowProps = {
  className?: string
  size?: string
  style?: React.CSSProperties
  theme?: string
}

export const Arrow = React.forwardRef<SVGSVGElement, ArrowProps>(
  ({ className, size, style, theme }, ref) => (
    <svg
      className={cx(
        styles.arrow,
        {
          [styles.size]: Boolean(size),
          [styles.theme]: Boolean(theme),
        },
        size && styles[size],
        theme && styles[theme],
        className,
      )}
      viewBox="0 2 14 12"
      {...{ ref, style }}
    >
      <path d="m0 14 5-8q2-3 4 0l5 8" />
    </svg>
  ),
)
